import _taggedTemplateLiteral from "/codebuild/output/src4034959427/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { basePropTypes, handleProps } from './utils';
import propsToCss from '../utils/propsToCss';
const StyledLink = styled(Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  ", "\n"])), props => propsToCss(props));
const StyledAnchor = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  ", "\n"])), props => propsToCss(props));
const LinkButton = _ref => {
  let {
    children,
    text,
    to,
    ...rest
  } = _ref;
  if (!to) {
    return null;
  }
  if (to.startsWith('http')) {
    return /*#__PURE__*/React.createElement(StyledAnchor, _extends({}, handleProps(rest), {
      href: to
    }), children || text);
  }
  return /*#__PURE__*/React.createElement(StyledLink, _extends({}, handleProps(rest), {
    to: to
  }), children || text);
};
LinkButton.propTypes = basePropTypes;
export default LinkButton;